"use client";
import { getRadius, getSize } from "../../core/utils/get-size/get-size.mjs";
import { createVarsResolver } from "../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { useStyles } from "../../core/styles-api/use-styles/use-styles.mjs";
import { polymorphicFactory } from "../../core/factory/polymorphic-factory.mjs";
import { Box } from "../../core/Box/Box.mjs";
import { UnstyledButton } from "../UnstyledButton/UnstyledButton.mjs";
import { Transition } from "../Transition/Transition.mjs";
import { Loader } from "../Loader/Loader.mjs";
import ActionIcon_module_default from "./ActionIcon.module.mjs";
import { ActionIconGroup } from "./ActionIconGroup/ActionIconGroup.mjs";
import { ActionIconGroupSection } from "./ActionIconGroupSection/ActionIconGroupSection.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/ActionIcon/ActionIcon.tsx
const varsResolver = createVarsResolver((theme, { size, radius, variant, gradient, color, autoContrast }) => {
	const colors = theme.variantColorResolver({
		color: color || theme.primaryColor,
		theme,
		gradient,
		variant: variant || "filled",
		autoContrast
	});
	return { root: {
		"--ai-size": getSize(size, "ai-size"),
		"--ai-radius": radius === void 0 ? void 0 : getRadius(radius),
		"--ai-bg": color || variant ? colors.background : void 0,
		"--ai-hover": color || variant ? colors.hover : void 0,
		"--ai-hover-color": color || variant ? colors.hoverColor : void 0,
		"--ai-color": colors.color,
		"--ai-bd": color || variant ? colors.border : void 0
	} };
});
const ActionIcon = polymorphicFactory((_props) => {
	const props = useProps("ActionIcon", null, _props);
	const { className, unstyled, variant, classNames, styles, style, loading, loaderProps, size, color, radius, __staticSelector, gradient, vars, children, disabled, "data-disabled": dataDisabled, autoContrast, mod, attributes, ...others } = props;
	const getStyles = useStyles({
		name: ["ActionIcon", __staticSelector],
		props,
		className,
		style,
		classes: ActionIcon_module_default,
		classNames,
		styles,
		unstyled,
		attributes,
		vars,
		varsResolver
	});
	return /* @__PURE__ */ jsxs(UnstyledButton, {
		...getStyles("root", { active: !disabled && !loading && !dataDisabled }),
		"aria-busy": loading || void 0,
		...others,
		unstyled,
		variant,
		size,
		disabled: disabled || loading,
		mod: [{
			loading,
			disabled: disabled || dataDisabled
		}, mod],
		children: [typeof loading === "boolean" && /* @__PURE__ */ jsx(Transition, {
			mounted: loading,
			transition: "slide-down",
			duration: 150,
			children: (transitionStyles) => /* @__PURE__ */ jsx(Box, {
				component: "span",
				...getStyles("loader", { style: transitionStyles }),
				"aria-hidden": true,
				children: /* @__PURE__ */ jsx(Loader, {
					color: "var(--ai-color)",
					size: "calc(var(--ai-size) * 0.55)",
					...loaderProps
				})
			})
		}), /* @__PURE__ */ jsx(Box, {
			component: "span",
			mod: { loading },
			...getStyles("icon"),
			children
		})]
	});
});
ActionIcon.classes = ActionIcon_module_default;
ActionIcon.varsResolver = varsResolver;
ActionIcon.displayName = "@mantine/core/ActionIcon";
ActionIcon.Group = ActionIconGroup;
ActionIcon.GroupSection = ActionIconGroupSection;
//#endregion
export { ActionIcon };

//# sourceMappingURL=ActionIcon.mjs.map